import { useTranslation } from "react-i18next";

import type { UiTheme } from "../theme";
import { Chip } from "../primitives/Chip";
import type { GridGestureBundle } from "./useGridGestures";

// The grid's two «one more» chips, «D ＋» and «W ＋» (PE-29, PE-45): the
// heatmap's structure row and the wide day grid (#336 slice 6) show the same
// ones. A tap on «W ＋» adds an empty week; `gesture` is its hold, which
// repeats the week on screen (useGridGestures' weekClone).
export function AddDayChip({ theme, onPress }: { theme: UiTheme; onPress: () => void }) {
  const { t } = useTranslation();
  return (
    <Chip
      theme={theme}
      shape="box"
      onPress={onPress}
      label="D ＋"
      accessibilityLabel={t("composer.addDay", { defaultValue: "Add day" })}
    />
  );
}

export function AddRoundChip({
  theme,
  onPress,
  gesture,
}: {
  theme: UiTheme;
  onPress: () => void;
  gesture?: GridGestureBundle;
}) {
  const { t } = useTranslation();
  return (
    <Chip
      theme={theme}
      shape="box"
      onPress={onPress}
      label="W ＋"
      accessibilityLabel={t("composer.addWeek", { defaultValue: "Add empty week" })}
      gesture={gesture}
    />
  );
}
